import { render, staticRenderFns } from "./ViewedProducts.vue?vue&type=template&id=2ebecb8e&"
import script from "./ViewedProducts.vue?vue&type=script&lang=js&"
export * from "./ViewedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports